import * as React from 'react';
import { Grid, StyledComponentProps } from '@material-ui/core';
import NewItemButton from '../../../ui-components/Button/NewItemButton';
import { SearchBoxApi } from '../../../ui-components/SearchBoxApi/SearchBoxApi';
import { contact } from '../../../model/contact';
import { invokeApi } from '../../../common/networking/invoker';

interface IProps extends StyledComponentProps {
    handleChangeFullnameOrEmail: (val: string) => void;
    fullnameOrEmail?: string;
    search: (fullnameOrEmail?: string, sub?: string) => void;
    new: () => void;
    loading: boolean;
}

const templateSearchBoxContact = (contact?: contact) => {
    return contact ? {
        label: (contact.surname ? contact.surname + " " + contact.name + " - " : "") + contact.email,
        value: contact
    } : undefined;
}
const searchContactsSearchBox = (search: string, take?: number): Promise<Array<contact>> => {
    return new Promise((resolve, reject) => {
        invokeApi({
            path: take ? `/api/Contacts?fullnameOrEmail=${search}&take=${take}`
                : `api/Contacts?fullnameOrEmail=${search}`,
            method: 'GET',
            responseType: "json",
        }).then(val => {
            resolve(val);
        }).catch(val => {
            reject(val)
        })
    })
}

export const Filters = (props: IProps) => {
    const classes = props.classes;
    // let contact: contact;
    return (
        <Grid container className={classes.root} spacing={2}>
            <Grid item xs={8} sm={8} >
                <SearchBoxApi<contact>
                    selectedItem={null} // props.selectedUser
                    openOnFocus
                    doFilter
                    disabled={false} // props.addInProgress
                    listSize={10}
                    getItems={searchContactsSearchBox}
                    label={"Utente"}
                    placeholder={"Digitare cognome o nome"}
                    templateItem={templateSearchBoxContact}
                    onSelectedChange={(item) => {
                        props.search(item?.sub);
                        //this.setContact(item) 
                    }} />
                {/* <TextField label='Cognome o Mail'
                    onKeyDown={(e) => {
                        //Enter KeyCode = 13
                        if (e.keyCode === 13) {
                            props.search(props.fullnameOrEmail) 
                        }
                    }}
                    disabled={props.loading} 
                    onChange={props.handleChangeFullnameOrEmail} 
                    value={props.fullnameOrEmail} /> */}
            </Grid>
            {/* <Grid item xs={3} sm={2} className={classes.searchButtons} >
                <div className={classes.searchButton}>
                    <Button className={classes.searchButton} onClick={() => props.search(props.fullnameOrEmail)}>Cerca</Button>
                </div>
            </Grid> */}
            <Grid item xs={4} sm={4} className={classes.searchButtons} >
                <div className={classes.searchButton}>
                    <NewItemButton disabled={props.loading} onClick={() => props.new()} text="Nuovo" />
                </div>
            </Grid>
        </Grid>
    );
}
